// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5b7e0de7","977":"84096bf4"}[chunkId] + ".chunk.js";
};